import React  from 'react';
import PropTypes from 'prop-types';

export default function DependenciesMoreItem(props) {
    if (props.tasks.length === 0) return false;

    return <div className="ui5-counter dark">+{props.tasks.length}</div>
}

DependenciesMoreItem.propTypes = {
    tasks: PropTypes.array,
}